<template>
  <!-- 视频右边 -->
  <div id="VideoInfo">
    <template v-if="data_isPay_b">
      <!-- 已支付样式(章节列表) -->
      <div class="videoList" :id="`${data_isShowPlayer_b ? '' : 'hasPlayer'}`">
        <h3>{{ data_videoInfo.name }}</h3>
        <ul v-if="data_videoInfo.normalCourseVideos && data_videoInfo.normalCourseVideos.length">
          <li :class="data_vid && data_vid === item.video.vid ? 'active' : ''"
            v-for="(item, index) in data_videoInfo.normalCourseVideos" :key="index" @click="data_payVideo(item)">
            <div class="public">
              <h5>{{ item.video.name }}</h5>
              <div v-if="item.video.speakerList.length || item.video.vid">
                <span v-for="(user, index) in item.video.speakerList" @click.stop="toPersonal(user)" :key="index"
                      :class="user.systemUserId ? 'active' : ''">{{ user.name }}</span>
                <i v-if="item.video.vid">时长：{{ videoDuration(item.video.duration) }}</i>
              </div>
            </div>
            <CourseListType :data_videoInfo="data_videoInfo" :item="item"/>
          </li>
        </ul>
        <Empty v-else class="courseListNull" :description="videoList_empty_null_text" />
        <div v-if="data_videoInfo.limitTimeFree === 'T' && data_limitTime_countDown_text" class="limitTimeFree">
          <div>
            限时免费 {{ data_limitTime_countDown_text }}
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <!-- 未支付样式 -->
      <div class="ocsInfo" :id="`${data_isShowPlayer_b ? '' : 'hasPlayer'}`">
        <h3>{{ data_videoInfo.name }}</h3>
        <span class="name">{{ data_videoInfo.speakerNames }}</span>
        <i class="price">
          <del v-if="data_videoInfo.activity && data_videoInfo.activity.promotionType === 'FIXED_DISCOUNT_PRICE'">
            ￥{{ data_videoInfo.money }}
          </del>
          <br />
          <b>¥{{ (data_videoInfo.activity &&
            data_videoInfo.activity.promotionType === 'FIXED_DISCOUNT_PRICE') ? data_videoInfo.activity.discount : amountPayable }}</b>
        </i>
        <p class="purchase"><template v-if="courseId != 2372 && courseId != 2449">已有{{ data_videoInfo.buys }}人购买</template></p>
        <ul class="buyBtn" v-if="data_videoInfo.name">
          <li @click="toPayAll">购买全部</li>
          <li v-if="data_videoInfo.payBodyType === 2" @click="toPaySingle">购买单节</li>
        </ul>
        <ul class="btns" v-if="data_videoInfo.name">
          <!-- 收藏 -->
          <li @click="data_isCollect_fn" :class="data_isCollect_b ? 'active' : ''">
            <HeartOutlined v-show="!data_isCollect_b" />
            <HeartFilled v-show="data_isCollect_b" />
            <i>{{ data_isCollect_b ? '已收藏' : '收藏' }}</i>
          </li>
          <li>
            <!-- 分享 -->
            <ShareAltOutlined />
            <i>分享</i>
            <div class="QRCode">
              <div>分享到微信</div>
              <div id="qrcodeCanvas"></div>
              <span>微信扫码分享</span>
            </div>
          </li>
        </ul>
      </div>
      <Modal v-model:data_isShow="isbuySingle_b" data_title="购买单节课程">
        <purchaseSeparately :data_videoInfo="data_videoInfo"/>
      </Modal>
    </template>
  </div>
</template>

<script>
import {
  PlayCircleFilled,
  HeartOutlined,
  ShareAltOutlined,
  HeartFilled,
} from "@ant-design/icons-vue";
import { button, Empty } from "ant-design-vue";
import { videoDuration, getUserId, add } from "@/utils/methods.js";
import Modal from "@c/Modal.vue";
import purchaseSeparately from "@c/course/purchaseSeparately.vue";
import QRCode from "qrcodejs2";
import CourseListType from "@c/course/CourseListType";

export default {
  name: "VideoInfo",
  components: {
    PlayCircleFilled,
    HeartOutlined,
    ShareAltOutlined,
    HeartFilled,
    [button.name]: button,
    Modal,
    QRCode,
    Empty,
    purchaseSeparately,
    CourseListType
  },
  props: ["data_isPay_b", "data_isShowPlayer_b", "data_videoInfo", "data_payVideo", "data_vid", "data_isCollect_fn", "data_isCollect_b", "data_limitTime_countDown_text"],
  data() {
    return {
      userId: getUserId(),
      // 未支付
      videoList_empty_null_text: '暂无课程',
      link: "",             // 分享连接
      isbuySingle_b: false, // 关闭支付功能时的弹窗开关
      courseId: this.$route.query.courseId ? this.$route.query.courseId : this.$route.params.videoId,
      amountPayable: 0,     // 价格
    };
  },
  computed: {
    // 根据 秒 转成 分钟：秒
    videoDuration() {
      return (second) => {
        return videoDuration(second);
      };
    },
  },
  methods: {
    // 全部购买
    toPayAll() {
      if(getUserId(true)){
        this.$router.push({
          path: '/pages/orderPay/orderPay',
          query: {
            courseId: this.data_videoInfo.id,
          }
        })
      }
    },
    // 购买单节
    toPaySingle() {
      if(getUserId(true)){
        this.isbuySingle_b = true;
      }
    },
    // 播放该视频
    playVideo_fn(item, index) {
      if (this.data_videoInfo.type === "F" || this.data_videoInfo.userCourseStatus === "W") {
        // 播放视频
        this.$emit('update:data_vid', item.video.vid);
      }
    },
    // 生成二维码
    setQRcode() {
      this.link = window.location.origin + '/ocscourse/#/pages/coursePlay/coursePlay?courseId=' + this.courseId;
      setTimeout(() => {
        if (!document.querySelector('#qrcodeCanvas')) {
          return;
        }
        document.querySelector('#qrcodeCanvas').innerHTML = '';
        // 因为可能获取不到页面dom所以延迟
        new QRCode("qrcodeCanvas", {
          width: 98,
          height: 98, // 高度
          text: this.link, // 二维码内容
          // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f',   // 背景色
          // foreground: '#ff0'    // 前景色
        });
      }, 1000)
    },
  },
  mounted() {
    // 生成二维码 这里和 videoPlayer.vue 文件中的二维码结构一样
    this.setQRcode()
  },
  watch: {
    $route(to, from) {
      this.setQRcode();
    },
    'data_videoInfo':{
      handler(n){
        if(n.payBodyType === 1){
          this.amountPayable = n.money;
        }else{
          n.normalCourseVideos.map(v=>{
            if (v.type === 2 && v.payStatus === 'F' && v.videoType !== 'O' && v.isTrial !== 'T') {
              this.amountPayable = add(v.courseVideoDiscountPrice ? v.courseVideoDiscountPrice : v.price,this.amountPayable);
            }
          })
        }
      },
    }
  },
};
</script>

<style scoped lang="scss">
#VideoInfo {
  flex: 1;
}

#hasPlayer {
  height: 442px;
}

.videoList {
  @extend %defaultBg;
  margin-left: 20px;
  border-radius: 6px;
  overflow: hidden;
  /*width: 100%;*/
  display: flex;
  flex-direction: column;
  height: 520px;
  min-height: 412px;

  h3 {
    font-size: 18px;
    padding: 10px 14px;
    background: #efefef87;
    font-weight: bold;
  }

  ul {
    @extend %scrollStyle;
    background: #f4f4f438;
    flex: 1;
    height: 0;
    overflow: auto;
    padding: 0 14px;

    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      background: #e3e3e3;
      border-radius: 10px;
    }

    li {
      padding: 12px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #646464;
      border-bottom: 1px solid #e5e5e5;
      cursor: pointer;

      .public {
        display: flex;
        flex-direction: column;

        h5 {
          font-size: 16px;
          margin-bottom: 4px;
        }

        div {
          margin-top: 10px;

          span {
            font-size: 12px;
            margin-right: 20px;

            &.active {
              color: #0581ce;
            }
          }

          i {
            font-size: 12px;
          }
        }
      }

      &.active {

        & .public *{
          color: $theme_blue !important;
          cursor: pointer;
        }
      }

      .anticon-play-circle {
        font-size: 20px;
        color: #bababa;
      }
    }
  }
}

.ocsInfo {
  /*width: 100%;*/
  @extend %defaultBg;
  margin-left: 20px;
  border-radius: 6px;
  padding: 33px 14px;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 520px;

  h3 {
    font-size: 20px;
    font-weight: bold;
  }

  .name {
    font-size: 16px;
    margin-top: 10px;
    font-weight: bold;
  }

  .price {
    font-size: 22px;
    color: #e7732e;
    margin-top: 10px;

    del {
      font-size: 16px;
      color: #aaa;
    }
  }

  .purchase {
    margin-top: 12px;
    font-size: 14px;
    color: #708aa2;
  }

  .buyBtn {
    font-size: 18px;

    color: #fff;
    width: 100%;
    line-height: 40px;
    text-align: center;
    font-weight: normal;
    /*margin-top: 44px;*/
    flex: 0 0 auto;
    user-select: none;
    cursor: pointer;
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    justify-content: space-around;
    padding: 0 20px;

    li {
      background: $theme_blue;
      border-radius: 6px;
      flex: 1;
      max-width: 80%;

      &:nth-of-type(2){
        margin-left: 20px;
      }
    }
  }

  .btns {
    /*margin-top: 40px;*/
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    li {
      display: flex;
      align-items: center;
      font-size: 16px;
      width: 90px;
      line-height: 34px;
      border-radius: 17px;
      background: #ececec;
      justify-content: center;
      box-sizing: border-box;
      cursor: pointer;
      user-select: none;
      position: relative;
      transition: all 0.3s;

      i {
        margin-left: 6px;
        font-size: 12px;
      }

      &.active {
        background: $theme_blue;
        color: #fff;
      }

      &:hover {
        background: $theme_blue;
        color: #fff;

        .QRCode {
          visibility: visible;
          opacity: 1;
          transform: translate(-50%, 0);
        }
      }

      .QRCode {
        width: 224px;
        background: #fff;
        border-radius: 6px;
        overflow: hidden;
        position: absolute;
        left: 50%;
        top: 50px;
        box-shadow: 0 0 10px 3px #ddd;
        transform: translate(-50%, 10%);
        display: flex;
        flex-direction: column;
        visibility: hidden;
        opacity: 0;
        transition: all 0.3s;
        transition-delay: 0.3s;
        color: #000;
        z-index: 1;

        div {
          line-height: 38px;
          background: #eff7ff;
          font-size: 14px;
          text-align: center;
        }

        #qrcodeCanvas {
          width: 98px;
          height: 98px;
          margin: 10px auto;
        }

        span {
          text-align: center;
          font-size: 14px;
          margin-bottom: 10px;
        }
      }
    }
  }
}

.courseListNull {
  margin: 30px 0;
}

.limitTimeFree {
  background: #f4f4f438;
  padding: 14px;

  div {
    color: #fff;
    font-size: 18px;
    line-height: 50px;
    text-align: center;
    background: #0581ce;
    border-radius: 6px;
  }
}</style>
